import React from "react";

/**
 * Pillar3D — pure-CSS isometric bar with 3 visible faces (front, top, right).
 *
 * Uses clip-path parallelograms for the top + right faces so it renders as a
 * real 3D-looking pillar (depth + perspective) without requiring three.js or
 * Plotly. The depth (in px) is controlled by the `depth` prop.
 */
export default function Pillar3D({ style, depth = 12, rounded = 4, children, className = "" }) {
  return (
    <div className={`relative ${className}`} style={{ filter: `drop-shadow(${style.glow})` }}>
      {/* Top face (parallelogram leaning back-right). */}
      <div
        aria-hidden
        className="pointer-events-none absolute"
        style={{
          top: -depth,
          left: 0,
          right: -depth,
          height: depth,
          background: style.top,
          clipPath: `polygon(${depth}px 0, 100% 0, calc(100% - ${depth}px) 100%, 0 100%)`,
        }}
      />
      {/* Right face (parallelogram going back-up). */}
      <div
        aria-hidden
        className="pointer-events-none absolute"
        style={{
          top: 0,
          right: -depth,
          bottom: 0,
          width: depth,
          background: style.side,
          clipPath: `polygon(0 ${depth}px, 100% 0, 100% 100%, 0 100%)`,
        }}
      />
      {/* Front face — the main rectangle. */}
      <div
        className="relative h-full w-full"
        style={{
          background: style.front,
          borderRadius: `${rounded}px ${rounded}px 0 0`,
          boxShadow: "inset 0 -3px 6px rgba(0,0,0,0.18), inset 1px 0 1px rgba(255,255,255,0.25)",
        }}
      >
        {children}
      </div>
    </div>
  );
}
